module.exports = __webpack_public_path__ + "media/images/coupon/img-nomulink-4ba987a7da88d7eb6e2cb51521eae9c8.png";